import RequestUtil from '../utils/RequestUtil'

import Const from '../consts/RequestConstant'

/**
 * 模块名+Service的命名规则
 */
class EquipmentService {

	/**
	 * 初始化实例变量
	 */
	constructor(_this) {
		this.$http = new RequestUtil();
		this.baseUrl = new Const();
		this._this = _this;
	}

	/*
	 * 获取设备列表
	 */
	equipmentList(param,callback) {
		this.$http.getRequest('ShopGoods/Get_GoodsInfoList', param, function(data) {
			 //console.log(data);			 
             callback && callback(data);
		});
	}
	
	/*
	 * 获取设备列表
	 */
	SalesmanGoodsInfoList(param,callback) {
		this.$http.getRequest('ShopGoods/Get_SalesmanGoodsInfoList', param, function(data) {
			 //console.log(data);
			 
             callback && callback(data);
		});
	}
	/*
	 * 获取随机设备列表
	 */
	GoodsRandomList(param,callback) {
		this.$http.getRequest('ShopGoods/Get_GoodsRandomList', param, function(data) {
			 //console.log(data);
			 
             callback && callback(data);
		});
	}
	
	/*
	 * 获取设备详情
	 */
	equipmentItem(param,callback){
		this.$http.getRequest('ShopGoods/Get_GoodsInfoItemDetail', param, function(data) {
			 //console.log(data);
			 
             callback && callback(data.rows);
		});
	}
	
	/*
	 * 获取类型列表
	 */
	equipmentType(param,callback){
		this.$http.getRequest('ShopGoods/GET_DeviceTypeList', param, function(data) {
			 //console.log(data);
			 
             callback && callback(data.rows);
		});
	}
	
	/*
	 * 获取省份列表
	 */
	provinceList(param,callback){
		this.$http.getRequest('ShopGoods/Get_ProvinceList', param, function(data) {
			 //console.log(data);
			 
             callback && callback(data.rows);
		});
	}
	
	/*
	 * 获取城市列表
	 */
	cityList(param,callback){
		this.$http.getRequest('ShopGoods/get_Area_CityList', param, function(data) {
			 //console.log(data);
			 
             callback && callback(data.rows);
		});
	}
	
	/*
	 * 获取年限、品牌
	 */
	deviceList(param,callback){
		this.$http.getRequest('ShopGoods/Get_DeviceParameterList', param, function(data) {
			 //console.log(data);
			 
             callback && callback(data.rows);
		});
	}
	
	/*
	 * 获取banner列表
	 */
	getBannerList(param,callback){
		this.$http.getRequest('Shop/Get_ShopBannerPicList', param, function(data) {
			 //console.log(data);
			 
             callback && callback(data.rows);
		});
	}
	
	/*
	 * 获取用户信息
	 */
	userInfo(param,callback){
		this.$http.getRequest('ShopUser/Get_MyCenterInfo', param, function(data) {
			 //console.log(data);
			 
             callback && callback(data.rows);
		});
	}
	
	/*
	 * 获取用户信息
	 */
	userInfoBase(param,callback){
		this.$http.getRequest('ShopUser/get_MyBaseInfo', param, function(data) {
			 //console.log(data);
			 
             callback && callback(data.rows);
		});
	}
	
	/*
	 * 发布信息
	 */
	setInfomation(path,param,callback){
		this.$http.postRequest('Goods/'+path, param, function(data) {
             callback && callback(data);
		});
	}
	
	/*
	 * 设置砍价
	 */
	setBargain(param,callback){
		this.$http.postRequest('Goods/set_AddDeviceBargainInfo', param, function(data) {
             callback && callback(data);
		});
	}
	/*
	 * 分期申请
	 */
	setInstallment(param,callback){
		this.$http.postRequest('Goods/set_AddDeviceLoanInfo', param, function(data) {
             callback && callback(data);
		});
	}
	/*
	 * 申请分期数列表\贷款成数
	 */
	getInstallment(param,callback){
		this.$http.getRequest('ShopGoods/get_DeviceParameterList', param, function(data) {
             callback && callback(data);
		});
	}
	
	/*
	 * 添加设备投保咨询信息
	 */
	setInsuranceInfo(param,callback){
		this.$http.postRequest('Goods/set_AddDeviceInsuranceInfo', param, function(data) {
             callback && callback(data);
		});
	}
	
	/*
	 * 判断用户绑定
	 */
	getBind(param,callback){
		this.$http.getRequest('ShopUser/get_IsBindUser', param, function(data) {
             callback && callback(data);
		});
	}
	
	/*
	 * 设置绑定
	 */
	setBind(param,callback){
		this.$http.postRequest('ShopUser/Set_UserTelBinding', param, function(data) {
             callback && callback(data);
		});
	}
	
	/*
	 * 分析功能
	 */
	getShare(param,callback){
		this.$http.getRequest1('ShareLoad.aspx', param, function(data) {
             callback && callback(data);
		});
	}
}

export default EquipmentService


// WEBPACK FOOTER //
// ./src/services/EquipmentService.js